import { FormEventHandler } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import {
  FieldErrors,
  SubmitHandler,
  UseFormReturn,
  useForm,
} from "react-hook-form";
import * as yup from "Utils/yup";

type FormData = {
  dangerZone?: string;
};

type UseDangerZoneProps = {
  dangerZone?: string;
  onConfirm: () => void;
};

type UseDangerZoneForm = {
  onSubmit: FormEventHandler<HTMLFormElement>;
  errors: FieldErrors<FormData>;
  methods: UseFormReturn<FormData>;
  isValid: boolean;
};

const useDangerZone = ({
  dangerZone,
  onConfirm,
}: UseDangerZoneProps): UseDangerZoneForm => {
  const validationText = `Text must match: ${dangerZone}`;

  const schema: yup.SchemaOf<FormData> = yup.object({
    dangerZone: dangerZone
      ? yup
          .string()
          .oneOf([dangerZone], validationText)
          .required(validationText)
      : yup.string().optional(),
  });

  const methods = useForm<FormData>({
    resolver: yupResolver(schema),
    mode: "onChange",
    defaultValues: { dangerZone: "" },
  });

  const {
    formState: { errors, isValid, isDirty },
    handleSubmit,
  } = methods;

  // this will only be called if the form is valid
  const onSubmit: SubmitHandler<FormData> = () => {
    onConfirm();
  };

  return {
    onSubmit: handleSubmit(onSubmit),
    isValid: dangerZone ? isValid && isDirty : true,
    errors,
    methods,
  };
};

export default useDangerZone;
